import { ItemClasses, PricingTypes } from "../../../common/constants";
import { YearlyBudget } from "../../../domain/budget";
import { WorkareaItemBase, createEstimatedItemFromCatalogItem } from "../../../domain/workareaItem";
import { centsToDollarsDisplay } from "../../displayFormatters";
import { GetJobWorkareaItemsResponse } from "../itemsApi";

type Option = {
  label: string
  value: number
}

export const buildLaborRateOptions = (data: GetJobWorkareaItemsResponse, budgets: YearlyBudget[]): Option[] => {
  const laborCatalogItemGuids = new Set<string>()
  const addIfLabor = (item: WorkareaItemBase) => {
    if (item.class === ItemClasses.Labor) {
      laborCatalogItemGuids.add(item.catalogItemGuid)
    }
  }
  data.estimatedItems.forEach(addIfLabor)
  data.actualItems.forEach(addIfLabor)

  const catalogItems = data.catalogItems.filter(x => laborCatalogItemGuids.has(x.guid))

  return [
    { label: 'Default', value: -1 },
    ...catalogItems.map(x => {
      const item = createEstimatedItemFromCatalogItem({
        catalogItem: x,
        workareaId: 0,
        budgets,
        pricingType: PricingTypes.QuotedPrice,
        quantity: 1,
        sortIndex: 0,
      })
      return { label: `${x.name}: ${centsToDollarsDisplay(item.unitPrice)}`, value: x.id }
    })
  ]
}
